// extracted by mini-css-extract-plugin
export default {"avatarCardHeight":"style_avatarCardHeight__fY1ot","avatarMaxwidth":"style_avatarMaxwidth__7Bp-S"};